/* tslint:disable */
/* eslint-disable */
/**
 * ELEMENTS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    ClickLinkUser,
    ClickLinkUserFromJSON,
    ClickLinkUserFromJSONTyped,
    ClickLinkUserToJSON,
} from './';

/**
 * 
 * @export
 * @interface ClickGalleryLink
 */
export interface ClickGalleryLink {
    /**
     * 
     * @type {number}
     * @memberof ClickGalleryLink
     */
    id?: number | null;
    /**
     * 
     * @type {string}
     * @memberof ClickGalleryLink
     */
    email?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof ClickGalleryLink
     */
    expiresAt?: Date | null;
    /**
     * 
     * @type {number}
     * @memberof ClickGalleryLink
     */
    galleryId: number;
    /**
     * 
     * @type {boolean}
     * @memberof ClickGalleryLink
     */
    notifyOnUse: boolean;
    /**
     * 
     * @type {number}
     * @memberof ClickGalleryLink
     */
    viewsLeft?: number | null;
    /**
     * 
     * @type {ClickLinkUser}
     * @memberof ClickGalleryLink
     */
    elementsUser?: ClickLinkUser;
    /**
     * 
     * @type {string}
     * @memberof ClickGalleryLink
     */
    secretKey?: string | null;
}

export function ClickGalleryLinkFromJSON(json: any): ClickGalleryLink {
    return ClickGalleryLinkFromJSONTyped(json, false);
}

export function ClickGalleryLinkFromJSONTyped(json: any, ignoreDiscriminator: boolean): ClickGalleryLink {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'email': !exists(json, 'email') ? undefined : json['email'],
        'expiresAt': !exists(json, 'expires_at') ? undefined : (json['expires_at'] === null ? null : new Date(json['expires_at'])),
        'galleryId': json['gallery_id'],
        'notifyOnUse': json['notify_on_use'],
        'viewsLeft': !exists(json, 'views_left') ? undefined : json['views_left'],
        'elementsUser': !exists(json, 'elements_user') ? undefined : ClickLinkUserFromJSON(json['elements_user']),
        'secretKey': !exists(json, 'secret_key') ? undefined : json['secret_key'],
    };
}

export function ClickGalleryLinkToJSON(value?: ClickGalleryLink | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'email': value.email,
        'expires_at': value.expiresAt === undefined ? undefined : (value.expiresAt === null ? null : value.expiresAt.toISOString()),
        'gallery_id': value.galleryId,
        'notify_on_use': value.notifyOnUse,
        'views_left': value.viewsLeft,
        'elements_user': ClickLinkUserToJSON(value.elementsUser),
        'secret_key': value.secretKey,
    };
}


